import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";

export default function BlogPost() {
    const { slug } = useParams();
    const [post, setPost] = useState(null);

    useEffect(() => {
        api.get(`/blog/${slug}`).then((r) => setPost(r.data));
    }, [slug]);

    if (!post) return (
        <>
            <Navbar variant="light" />
            <div className="pt-32 container-edge label-overline text-wine-dark/60">A carregar…</div>
        </>
    );

    return (
        <>
            <Navbar variant="dark" />
            <section className="relative h-[60vh] min-h-[480px] bg-wine-deep overflow-hidden">
                <img src={post.cover} alt={post.title} className="absolute inset-0 w-full h-full object-cover kenburns" />
                <div className="absolute inset-0 bg-gradient-to-b from-wine-deep/30 to-wine-deep/90" />
                <div className="relative container-edge h-full flex flex-col justify-end pb-16 text-cream max-w-4xl">
                    <span className="label-overline text-gold-soft">{post.category}</span>
                    <h1 className="mt-6 font-heading text-4xl md:text-6xl leading-[0.98] text-shadow-soft">{post.title}</h1>
                </div>
            </section>
            <article className="bg-beige-natural py-20">
                <div className="container-edge max-w-3xl prose-content text-wine-dark/85 leading-relaxed text-lg whitespace-pre-line">
                    {post.content}
                </div>
                <div className="container-edge max-w-3xl mt-16">
                    <Link to="/blog" className="label-overline text-wine hover:text-gold-soft">← Voltar ao Diário</Link>
                </div>
            </article>
            <Footer />
        </>
    );
}
